// extracted by mini-css-extract-plugin
export default {"root":"Avatar_root__p2Y4k","name":"Avatar_name__1IMcq","skills":"Avatar_skills__EJM77","editButton":"Avatar_editButton__cCb0m","bio":"Avatar_bio__+13EO"};